<template>
	<div :id="mainNavIsHidden ? 'main-nav-hidden' : 'cash-out'">
		<h1>{{ languageStrings.webPayCashOut }}</h1>
		<div v-if="countryCode !== 'MX' && casinoList.length > 1">
			<h2>{{ languageStrings.selectCasino }}</h2>
			<DropdownMenu id="casino-select" :casinoList="casinoList" :languageStrings="languageStrings" />
		</div>
		<div v-if="!hideProgressBar" class="encore-color  center-progress-info">
			<table class="center-content panel space-between-table">
				<thead class="table-header-section">
					<tr>
						<th>Requisitos de Apuesta</th>
					</tr>
				</thead>
				<tr class="center-expandable-row">
					<div class=" bold-text progress-bar-section center-content progress-bar-centering">
						<div class="progress-color changing-font-size left-spacing">{{ playthroughProgress }}</div>
						<div class="meter space-between-bar-and-number progress-bar-width">
    						<span :id="createId(0)"></span>
  						</div>
						<div class="black-color changing-font-size right-spacing">{{ playthroughThreshold }}</div>
					</div>
				</tr>
				<a v-if="isExpanded" @click="getTermsAndConditions()" class="center-content terms-and-conditions">{{ languageStrings.termsAndConditions }}</a>
				<tbody class="display-panel center-tbody-data"  id="wager-table">
					<tr :class="isExpanded ? ' open': 'closed'">
						<table class="full-width">							
							<tr>
								<td class="center-table-data wager-details">{{ languageStrings.wagerProgress }}</td>
								<td class=" bold-text progress-color space-betwen-values changing-font-size">{{ playthroughProgress }}</td>
							</tr>
							<tr>
								<td class="center-table-data wager-details">{{ languageStrings.remainderToWager }}</td>
								<td class="bold-text remainder-color space-betwen-values changing-font-size">{{ remainderOfWager }}</td>
							</tr>
							<tr>
								<td class=" center-table-data wager-details">{{ languageStrings.wagerRequirement }}</td>
								<td class="bold-text black-color space-betwen-values changing-font-size">{{ playthroughThreshold }}</td>
							</tr>
						</table>
					</tr>
				</tbody>
				<tr :class="isExpanded ? ' open': 'closed'" style="border-top: 2px solid #6305C9;"></tr>
				<tbody class="display-panel center-tbody-data"  id="wager-table">
					<tr :class="isExpanded ? ' open': 'closed'" >
						<table>
							<tr>
								<td class="center-table-data balance-details">{{ languageStrings.actualBalance }}</td>
								<td class="bold-text black-color space-betwen-values changing-font-size">{{ regularCredits }}</td>
							</tr>
							<tr>
								<td class="center-table-data balance-details">{{ languageStrings.pendingWinnings }}</td>
								<td class="bold-text promo-color space-betwen-values changing-font-size">{{ promoCredits }}</td>
							</tr>
						</table>
					</tr>
				</tbody>
				<tr style="border-top: 2px solid #6305C9;">
				</tr>
				<div class="background-for-arrow"  @click="expandRow()">
					<tr  class="center-dot">
						<div>
							<div v-if="!isExpanded" >
								<i class="arrow down align-arrow" ></i>
							</div>
							<div v-else class="center-arrow-up">
								<i class="arrow up align-arrow"></i>
							</div>	
						</div>
					</tr>
				</div>
			</table>
			<!-- <div class=" bold-text center-content">{{ getPercentage() }}%</div> -->
			
			<!-- <a @click="getTermsAndConditions()" class="center-content terms-and-conditions">{{ languageStrings.termsAndConditions }}</a> -->
			
		</div>
		<div id="select-container">
					<h3 style="color: black;">{{ languageStrings.selectPaymentType }}</h3>
					<select
						:title="languageStrings.selectProvider"
						class="curved-border encore-color select-width"
						v-model="provider"
						id="paymentOptions"
					>
						<option v-for="(item, index) in paymentOptions" :key="index" :value="item">
							{{ item.key }}
						</option>
					</select>
				</div>
		<div v-if="selectedCasino?.id" class="cash-out-container">
			<div class="content-container">
				<!-- <div id="select-container">
					<h3>{{ languageStrings.selectProvider }}</h3>
					<select
						:title="languageStrings.selectProvider"
						class="curved-border encore-color select-width"
						v-model="provider"
						id="paymentOptions"
					>
						<option v-for="(item, index) in paymentOptions" :key="index" :value="item">
							{{ item }}
						</option>
					</select>
				</div> -->
				<div id="nuvei-component">
					<NuveiCashOut
						v-if="webPayOptions?.nuvei && provider.provider === 'Nuvei'"
						:playerState="playerState"
						:webPayOptions="webPayOptions"
						:systemCurrencyTool="systemCurrencyTool"
						:languageErrorStrings="languageErrorStrings"
						:languageStrings="languageStrings"
						:provider="provider"
						:selectedCasino="selectedCasino"
					/>
				</div>
				<div id="conekta-component">
					<ConektaCashOut
						v-if="webPayOptions?.conekta && provider.provider === 'Conekta'"
						:playerState="playerState"
						:webPayOptions="webPayOptions"
						:systemCurrencyTool="systemCurrencyTool"
						:languageErrorStrings="languageErrorStrings"
						:languageStrings="languageStrings"
						:provider="provider"
						:selectedCasino="selectedCasino"
					/>
				</div>
				<div id="directa-component">
					<DirectaCashOut
						v-if="webPayOptions?.directa && provider.provider === 'Directa'"
						:playerState="playerState"
						:webPayOptions="webPayOptions"
						:systemCurrencyTool="systemCurrencyTool"
						:languageErrorStrings="languageErrorStrings"
						:languageStrings="languageStrings"
						:provider="provider"
						:selectedCasino="selectedCasino"
					/>
				</div>
			</div>
		</div>
	</div>
	<div v-if="showTermsAndConditions">
				<!-- <TermsAndConditions
					:playerState="playerState"
					:languageStrings="languageStrings"
					:languageErrorStrings="languageErrorStrings"
					:tosContent="tosContent"
					:latestVersion="latestVersion"
					:showAcceptAndContinue="false"
					:isMobile="isMobile"
				/> -->
				<DocumentDisplay
					:playerState="playerState"
					:isMobile="isMobile"
					:languageStrings="languageStrings"
					:languageErrorStrings="languageErrorStrings"
					:newDocuments="newDocuments"
					:documentList="documentList"
					:showAcceptAndContinue="false"
				/>

	</div> 
	<!-- </div> -->
</template>

<script>
import { onBeforeUnmount } from "vue";
import CurrencyTool from "@/dependencies/currencyTool";
import sharedScripts from "@/dependencies/sharedScripts";
import DropdownMenu from "@/components/DropdownMenu";
import NuveiCashOut from "@/components/NuveiCashOut";
import ConektaCashOut from "@/components/ConektaCashOut";
import DirectaCashOut from "@/components/DirectaCashOut";
import router from "@/router";
import TermsAndConditions from "@/components/TermsAndConditions";
import DocumentDisplay from "@/components/DocumentDisplay.vue";

export default {
	name: "WebPayCashOut",
	inheritAttrs: false,
	props: {
		casinoList: Array,
		playerState: Object,
		isMobile: Boolean,
		inGameCurrencyTool: Object,
		systemCurrencyTool: Object,
		languageStrings: Object,
		languageErrorStrings: Object,
		systemSettings: Object,
		mainNavIsHidden: Boolean,
		hasBeenBlockedForBuyInAndCashOut: Boolean
	},
	components: {
		DropdownMenu,
		NuveiCashOut,
		ConektaCashOut,
		DirectaCashOut,
		TermsAndConditions,
		DocumentDisplay
	},
	data() {
		return {
			status: Object.assign({}, this.globalStatus),
			serverBusy: false,
			busyText: "",
			cashOutCurrency: {},
			inGameCurrencyInfo: {},
			nuveiResult: {},
			nuveiDialog: null,
			selectedCasino: null,
			casinoId: null,
			nuveiShow: false,
			rabbitsfootMessage: null,
			webPayOptions: {},
			toPlayerCashCOC: null,
			paymentType: null,
			allowCashOutLATAM: false,
			allowCashOutSTPmex: false,
			safeChargeApiResult: null,
			buttonText: "",
			transactionStatus: null,
			transactions: null,
			checkoutStatus: "",
			paymentOptions: [],
			provider: "",
			playthroughProgress: this.systemCurrencyTool?.formatFromAU(this.playerState?.casinoBalances[0]?.playthroughProgressAU,this.systemCurrencyTool.displayType.full),
			playthroughThreshold: this.systemCurrencyTool?.formatFromAU(this.playerState?.casinoBalances[0]?.playthroughThresholdAU,this.systemCurrencyTool.displayType.full),
			percentage: null,
			hideProgressBar: true,
			regularCredits: null,
			promoCredits: null,
			remainderOfWager: null,
			tosContent: "",
			latestVersion: {},
			showTermsAndConditions: false,
			isExpanded: false,
			newDocuments:[]
		};
	},
	watch: {
		casinoId() {
			if (this.casinoId) this.getWebPayOptions();
		},
		casinoList(){
			if (this.countryCode === "MX" || this.casinoList.length === 1)
				this.eventBus.emit("casinoSelected", this.pickDefaultCasino());
		},
		hasBeenBlockedForBuyInAndCashOut() {
		},
		playerState() {
			//this.checkForCurrentCasinoAndSetValues();
		}
	},
	created() {
		this.eventBus.on("casinoSelected", (payload) => {
			this.selectedCasino = payload;
			this.casinoId = payload?.id;
			this.inGameCurrencyInfo = new CurrencyTool(payload?.inGameCurrencyInfo, this.localeString);
		});
		onBeforeUnmount(() => {
			this.eventBus.off("casinoSelected");
		});
		if (this.casinoId) this.getWebPayOptions();
		this.eventBus.on("closeTos", () => {
			this.showTermsAndConditions = false;
		});
	},
	mounted() {
		for(let i = 0; i < this.playerState?.casinoBalances.length; i++) {
			if(this.playerState?.casinoBalances[i]?.casinoId == this.playerState?.casinoId) {
				this.regularCredits = this.systemCurrencyTool.formatFromAU(this.playerState.casinoBalances[i].balance.regularAU, this.systemCurrencyTool.displayType.full);
				this.promoCredits = this.systemCurrencyTool.formatFromAU(this.playerState.casinoBalances[i].balance.promoAU, this.systemCurrencyTool.displayType.full);
				let difference = this.playerState?.casinoBalances[i]?.playthroughThresholdAU - this.playerState?.casinoBalances[i]?.playthroughProgressAU;
				this.remainderOfWager = this.systemCurrencyTool.formatFromAU(difference, this.systemCurrencyTool.displayType.full);
				if(this.playerState?.casinoBalances.length == 0 || this.playerState?.casinoBalances[i]?.playthroughThresholdAU == 0){ this.hideProgressBar = true; }
				else{ this.hideProgressBar = false; }

			}
		}
		
		// this.regularCredits = this.systemCurrencyTool.formatFromAU(this.playerState.casinoBalances[0].balance.regularAU, this.systemCurrencyTool.displayType.full);
		// this.promoCredits = this.systemCurrencyTool.formatFromAU(this.playerState.casinoBalances[0].balance.promoAU, this.systemCurrencyTool.displayType.full);
		// let difference = this.playerState?.casinoBalances[0]?.playthroughThresholdAU - this.playerState?.casinoBalances[0]?.playthroughProgressAU;
		// this.remainderOfWager = this.systemCurrencyTool.formatFromAU(difference, this.systemCurrencyTool.displayType.full);
		// if(this.playerState?.casinoBalances.length == 0 || this.playerState?.casinoBalances[0]?.playthroughThresholdAU == 0){ this.hideProgressBar = true; }
		// else{ this.hideProgressBar = false; }

		//this.checkForCurrentCasinoAndSetValues();
		console.log("this is the player state", this.playerState);

		if(this.hasBeenBlockedForBuyInAndCashOut) router.push("/");
		if (this.countryCode === "MX" || this.casinoList.length === 1)
			this.eventBus.emit("casinoSelected", this.pickDefaultCasino());
	},
	methods: {

		checkForCurrentCasinoAndSetValues() {
			for(let i=0; i< this.playerState?.casinoBalances.length; i++) {
				if(this.playerState.casinoId == this.playerState?.casinoBalances[i].casinoId) {

					if(this.playerState?.casinoBalances[i]?.playthroughThresholdAU == 0) this.hideProgressBar = true;
					else { 
						this.hideProgressBar = false;
						this.regularCredits = this.systemCurrencyTool.formatFromAU(this.playerState.casinoBalances[i].balance.regularAU, this.systemCurrencyTool.displayType.full);
						this.promoCredits = this.systemCurrencyTool.formatFromAU(this.playerState.casinoBalances[i].balance.promoAU, this.systemCurrencyTool.displayType.full);
						let difference = this.playerState?.casinoBalances[i]?.playthroughThresholdAU - this.playerState?.casinoBalances[i]?.playthroughProgressAU;
						this.remainderOfWager = this.systemCurrencyTool.formatFromAU(difference, this.systemCurrencyTool.displayType.full);
						this.playthroughProgress = this.systemCurrencyTool?.formatFromAU(this.playerState?.casinoBalances[i]?.playthroughProgressAU,this.systemCurrencyTool.displayType.full);
						this.playthroughThreshold =  this.systemCurrencyTool?.formatFromAU(this.playerState?.casinoBalances[i]?.playthroughThresholdAU,this.systemCurrencyTool.displayType.full);
					}
				}
			}
		},
		getPaymentOptions() {
			let webPayKeys = this.webPayOptions.cashOutPaymentMethods;
			webPayKeys.forEach((cashOutMethod) => {
				// if(cashOutMethod.key === "DebitCard") {
				// 	cashOutMethod.key = this.languageStrings.debitCard;
				// }
				// if(cashOutMethod.key === "ToditoCash") {
				// 	cashOutMethod.key = this.languageStrings.toditoCash;
				// }
				// if(cashOutMethod.key === "OxxoPay") {
				// 	cashOutMethod.key = this.languageStrings.oxxoPay;
				// }
				//currently we only want to show Spei option for now, this can be changed on the server side but they are busy right now
				// so this is only a band-aid for now 6/12/25

				if(cashOutMethod.key == "Spei") {
					this.provider = cashOutMethod;
					this.paymentOptions.push(cashOutMethod);
				}

				//this.paymentOptions.push(cashOutMethod);
			});
		},
		pickDefaultCasino() {
			let casinoIdSelected;
			casinoIdSelected = this.casinoList.filter((casino) => casino.isEnabled === true)[0];
			return casinoIdSelected;
		},
		async getWebPayOptions() {
			this.busyText = this.languageStrings.loadingBuyIns;
			this.serverBusy = true;

			// Check if session needs to be refreshed
			let success = await this.authenticationCheck(this);
			if (success.hasOwnProperty("ok") && !success.ok) {
				this.serverBusy = false;
				this.busyText = "";
				return false;
			}

			let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.playerState.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");
			let requestUrl = new URL(`/api/v1/webpay/options`, this.rabbitsfootHostUrl);
			let params = requestUrl.searchParams;

			if (this.playerState.casinoId) params.set("casinoId", this.playerState.casinoId);
			else{
				params.set("casinoId", this.casinoId);
			}
			
			requestUrl.search = params.toString();

			let request = new Request(requestUrl.toString(), {
				method: "GET",
				headers: headerObj,
			});

			try {
				let response = await fetch(request);

				let fetchStatus = sharedScripts.checkFetchErrors(response, this.languageErrorStrings);

				if (fetchStatus && !fetchStatus.ok) {
					this.serverBusy = false;
					this.eventBus.emit("updateStatus", fetchStatus);
					if (fetchStatus.forceLogout) this.eventBus.emit("forceLogout");
					return false;
				}

				let dataJson = await response.json();

				if(dataJson.account != null) this.playerState.casinoId = dataJson.account.casinoId;

				this.webPayOptions = dataJson;
				// this.availableOffers = dataJson.availableOffers;
				this.inGameCurrencyInfo = dataJson.casino?.currencyInfo;

				// if (this.webPayOptions?.nuvei?.allowCashOutLATAM)
				// 	this.allowCashOutLATAM = this.webPayOptions.nuvei.allowCashOutLATAM;
				// if (this.webPayOptions?.nuvei?.allowCashOutSTPmex)
				// 	this.allowCashOutSTPmex = this.webPayOptions.nuvei.allowCashOutSTPmex;

				let _state = this.playerState;
				_state.restrictedNeedsMoreInfo =
					dataJson?.taxAmlRestrictions?.idCheckNeeded || dataJson?.taxAmlRestrictions?.morePersonalInfoNeeded;
				this.eventBus.emit("updatePlayerState", _state);

				this.getPaymentOptions();

				this.serverBusy = false;
				this.busyText = "";
			} catch (e) {
				this.status.ok = false;
				this.status.message = e;
				console.error(e);
				this.serverBusy = false;
				this.busyText = "";
			}
		},
		createId(item) {
			setTimeout(() => {
				this.setPercentage(item);
			}, 5);
			return `progress-bar-${item}`;
		},

		setPercentage(item){
			document.getElementById(`progress-bar-${item}`).style.width = `${this.getPercentage()}%`;
		},

		getPercentage() {
			for(let i=0; i< this.playerState?.casinoBalances.length; i++) {
				if(this.playerState.casinoId == this.playerState?.casinoBalances[i].casinoId) {
					if(this.playerState?.casinoBalances[i]?.playthroughProgressAU == 0 && this.playerState?.casinoBalances[i]?.playthroughThresholdAU == 0){ return null;}
					this.percentage = Math.floor((this.playerState?.casinoBalances[i]?.playthroughProgressAU / this.playerState?.casinoBalances[i]?.playthroughThresholdAU) * 100);
				}
			}
			
			if(this.playerState.casinoBalances.length == 0){ return 0;}		
			return this.percentage;
		},

		async getLatestTosDocument() {
			this.serverBusy = true;
			this.busyText = this.languageStrings.loadingTermsAndConditions;
			
			try {
				this.tosList = await this.listDocuments(this,"tos", 10);
				if (!this.tosList?.length > 0) {
					this.serverBusy = false;
					this.busyText = "";
					this.status.message = "There are no tos files avaliable";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				}
				this.latestVersion = this.compareDocumentVersions(this.tosList);

				let documentUrl =
					this.latestVersion.url.indexOf("http") === 0
						? this.latestVersion.url
						: `./${this.latestVersion.url}`;

				let content = await fetch(documentUrl);
				let dataJson = await content.text();
				this.tosContent = this.removeScriptTag(dataJson);
				this.showTermsAndConditions = true;
				this.newDocuments.push(this.latestVersion);

				this.serverBusy = false;
				this.busyText = "";
			} catch (e) {
				console.error(e);
				this.serverBusy = false;
				this.busyText = "";
				this.status.ok = false;
				this.status.message = e;
				this.eventBus.emit("updateStatus", this.status);
			}
		},

		getTermsAndConditions(){
			this.getLatestTosDocument();
		},

		expandRow() {
			let wagerTable = document.getElementById("wager-table")
			// wagerTable.classList.contains("open") ? wagerTable.classList.remove("open"): wagerTable.classList.add("open");
			this.isExpanded = !this.isExpanded;
		}
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
	text-align: center;
}

#cash-out {
	display: grid;
	width: 95%;
	margin: auto;
}

#cash-out {
	/* ****** temp fix for a CSS bug I need to understand ****** */
	top: 115px;
	/* left: 20px; */
}

.input-section {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 95%;
	margin-top: 2vh;
	margin-left: auto;
	margin-right: auto;
}

.input-section > span {
	display: flex;
	align-items: center;
	margin-left: 10px;
}

#nuvei-container {
	display: none;
}

#nuvei-container.show {
	display: grid;
	align-items: center;
	position: absolute;
	top: 0;
	margin: auto;
	height: 100%;
	width: 100%;
	background-color: #000;
}

#nuvei-dialog {
	width: 80%;
	margin: auto;
	background-color: #000;
	color: #fff;
	border-radius: 12px;
	border-width: 1px;
	box-sizing: border-box;
	text-align: center;
}

::backdrop {
	background-color: #000;
	backdrop-filter: blur(8px);
	opacity: 0.75;
}

#btn-container {
	display: flex;
	flex-flow: row wrap;
	justify-content: center;
}

#btn-container a {
	text-decoration: none;
}

#btn-container * {
	margin: 15px;
}

select#offer-payment-type {
	width: 100%;
	height: 5vh;
	text-align: center;
	margin-left: 6vw;
	color: #5d3fd3;
	font-weight: bolder;
}

#payment-type-section {
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-top: 19px;
	/* margin-left: 1vw; */
	width: 75%;
}

#balances {
	background: white;
	display: flex;
	align-items: center;
	color: #5d3fd3;
	border-radius: 25px;
	width: 75%;
	margin-right: auto;
	margin-left: auto;
	font-size: 17px;
	font-weight: bolder;
	height: 5vh;
	margin-top: 3vh;
}

#toPlayerCashCOC {
	border-radius: 25px;
	width: 100%;
	height: 4.6vh;
	color: #5d3fd3;
	text-align: center;
	margin-right: 3vw;
}

.button-container {
	background: white;
	border-radius: 15px;
	width: 11vw;
	margin: 15px auto;
}

.buy-in-btn {
	-webkit-text-fill-color: transparent;
	background-clip: text;
	margin: auto;
	width: 11vw;
	height: 4.5vh;
	font-weight: bolder;
	overflow-wrap: break-word;
}

.button-container:hover {
	width: 22.5vw;
	padding-left: 6px;
}

.current-balance {
	margin: 4px auto;
}

iframe {
	margin: auto;
	width: 90;
	height: 400px;
	border-radius: 12px;
}

.cash-out-container {
	background-image: url("../../public/styleOverrides/encore_online_pixel_bg.png");
	width: 60%;
	border-radius: 12px;
	margin: auto;
	padding: 15px;
}

#select-container {
	margin: 15px auto;
	/* display: grid; */
	align-items: center;
	/* width: 230px; */
	/* height: 100%; */
	justify-content: center;
	text-align: center;
}

#select-container > * {
	padding: 5px 15px;
}

#align-min-max {
	margin-top: 6px;
}
.expand-input-mobile {
	width: 40%;
}

#main-nav-hidden {
	width: 100%;
	margin-left: 0;
	background-color: white;
	height: 100vh;
	margin-top: 116px;
}

h1 {
	color: black;
}

.curved-border {
	font-weight: bold;
}

.meter {
	box-sizing: content-box;
  	height: 8px;
  	position: relative;
  	background: #ccc;
  	border-radius: 25px;
  	padding: 7px;
  	box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.507);
	width: 70%;
}

.meter > span {
  display: block;
  height: 100%;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  background-color: #6305C9;
  background-image: linear-gradient(
    center bottom,
   #6305C9 37%,
   #6305C9 69%
  );
  box-shadow: inset 0 2px 9px rgba(255, 255, 255, 0.3),
    inset 0 -2px 6px rgba(0, 0, 0, 0.4);
  position: relative;
  overflow: hidden;
}

.meter > span:after,
.animate > span > span {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-image: linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
  z-index: 1;
  background-size: 50px 50px;
  animation: move 2s linear infinite;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  overflow: hidden;
}

.animate > span:after {
  display: none;
}

.progress-bar-percentage {
	margin-left: 3%;
}

.progress-bar-section {
	display: flex;
	margin-top: 1vh;
	width: 50%;
	margin-left: auto;
	margin-right: auto;
}

.progress-bar-centering {
	margin-bottom: 1%;
	margin-top: 2%;
	align-items: center;
}

.align-dot {
	margin-right: 5px;
}

.align-arrow {
	margin-right: 8px;
	margin-left: 8px;
}

.center-expandable-row {
	height: 5vh;
	display: flex;
	justify-content: center;
	align-items: center;
}

.changing-font-size {
	font-size: clamp(10px,2.7vw,12px);
}

.progress-bar-width {
	width:53vw;
	min-width: 30vw;
}

.full-width {
	width: 100%;
}

.wager-details {
	font-size: small;
	margin-right: 10%;
	white-space: nowrap;
}

.balance-details {
	font-size: small;
	margin-right: 15px;
	white-space: nowrap;
}

.table-header-section {
	background-color: #6305C9;
	color: white;
	justify-content: center;
	display: flex;
	height: 3.5vh;
	align-items: center;
	border-radius: 5px 5px 0 0;
}

.space-between-bar-and-number {
	margin-left: 5px;
	margin-right: 5px;
}

.panel{
	display: flex;
	flex-direction: column;
	display: table-row;
	background-color: white;
	/* color: white; */
	color: #6305C9;
	border-radius: 12px;
	border-color: #6305C9;
	border: solid 3px #6305C9;
	padding: 0px;
}

.space-between-table-elements {
	padding-left: 10%;
}

.center-progress-info {
	width: 97%;
	margin-left: auto;
	margin-right: auto;
}

.space-between-table {
	margin-top: 2%;
}

a:hover {
	cursor: pointer;
}

a {
	text-decoration: underline;
}

@keyframes move {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 50px 50px;
  }
}

.center-content {
	display: flex;
	justify-content: center;
	/* align-items: center; */
}

.black-color {
	color: #000;
}

.progress-color {
	color: #747474;
}

.remainder-color {
	color: rgba(0, 0, 0, 0.75);
}

.promo-color {
	color: #F74D4D;
}

.terms-and-conditions {
	color: #6305C9;
	margin-bottom: 1%;
	font-size: x-small;
	font-weight: bold;
}

.right {
	transform: rotate(-45deg);
	-webkit-transform: rotate(-45deg);
}

.display-panel .closed {
	display: none;
}

.display-panel .open {
	/* display: flex; */
	/* height: 150px; */
	background-color: white;
	border-radius: 12px;
}

.center-tbody-data {
	display: flex;
	justify-content: center;
	align-items: center;
}

hr.solid {
	border-top: 2.5px solid #6305C9;
}

.dot {
	height: 25px;
	width: 25px;
	background-color: #6305C9;
	border-radius: 50%;
	display: inline-block;
}

.arrow {
	border: solid #6305C9;
	border-width: 0 3px 3px 0;
}

.center-dot {
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 5px;
}

.center-dot:hover {
	cursor: pointer;
}

.background-for-arrow {
	background-color: #D9D9D9;
	display: flex;
	border-radius: 0 0 10px 10px;
}

.center-arrow-up {
	margin-top: 4px;
}
@media (min-width: 768px) {
	#cash-out {
		width: 80%;
		margin-left: 20%;
		position: absolute;
	}

	#nuvei-dialog {
		width: 50%;
	}
	iframe {
		margin: auto;
		width: 50%;
	}
	.space-betwen-values {
		/* padding-right: 19vw; */
		padding-left: 2vw;
	}
	.center-table-data {
		/* padding-left: 11vw; */
	}
	.move-arrow {
		padding-left: 20vw;
	}
	.center-progress-info {
		width: 66%;
	}
	
}

@media (min-width: 1629px) {
	.playerCashCOC {
		margin-left: 5.5vw;
	}
}

@media (max-width: 820px) {
	.cash-out-container {
		width: 90%;
		border-radius: 12px;
		margin-left: auto;
		margin-right: auto;
		/* height: 390px; */
	}

	.button-container {
		background: white;
		border-radius: 15px;
		width: 35vw;
		margin-left: auto;
		margin-right: auto;
		margin-top: 7.5vh;
	}

	.button-container:hover {
		width: 36vw;
	}

	.buy-in-btn {
		background: linear-gradient(to right, blue, purple, #fa5f55);
		-webkit-text-fill-color: transparent;
		background-clip: text;
		margin: auto;
		border-radius: 15px !important;
		width: 35vw;
		height: 4.5vh;
		font-weight: bolder;
		overflow-wrap: break-word;
	}

	.content-container {
		display: flex;
		flex-direction: column;
	}

	#balances {
		width: 90%;
	}

	#toPlayerCashCOC {
		border-radius: 25px;
		width: 100%;
		height: 4.6vh;
		color: #5d3fd3;
		text-align: center;
		margin-right: 0;
	}

	#payment-type-section {
		width: 90%;
		margin-left: auto;
		margin-right: 7vw;
	}

	#payment-type-label {
		margin-left: 9vw;
	}

	select#offer-payment-type {
		width: 65%;
		height: 5vh;
		text-align: center;
		margin-left: 1vw;
		color: #5d3fd3;
		font-weight: bolder;
	}

	#select-container {
		/* display: grid; */
		width: 230px;
		justify-items: center;
	}

	.select-width {
		width: 130px;
	}

	#cash-out {
		margin-top: 96px;
	}
	
	.small-font {
		font-size: 15px;
	}

	.progress-bar-section {
		width: 100%;
	}

	.space-between-table-elements {
		padding-left: 6%;
	}

	.display-panel .open {
		display: initial;
		background-color: white;
	}
	.space-betwen-values {
		padding-left: 2vw;
	}

	.right-spacing {
		margin-right: 4px;
	}

	.left-spacing {
		margin-left: 4px;
	}
}
</style>
